// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,Badge,
  useColorModeValue,
  useColorMode,
} from "@chakra-ui/react";
// Custom Components
import { ItemContent } from "components/menu/ItemContent";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { SidebarResponsive } from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import React,{useEffect,useState} from "react";
import axios from "../../api/index";
// Assets
import { useHistory } from "react-router-dom";
import { useAuth } from "../../auth-context/auth.context";
import AuthApi from "../../api/auth";

import navImage from "assets/img/layout/Navbar.png";
import { MdNotificationsNone, MdInfoOutline } from "react-icons/md";
import { IoMdMoon, IoMdSunny } from "react-icons/io";
import { FaEthereum } from "react-icons/fa";
// import routes from "routes.js";

export default function HeaderLinks(props) {
    const { secondary, routes = [] } = props; // ✅ Correct destructuring
  const history = useHistory();
  const { setUser } = useAuth();
  let { user } = useAuth();
  //const { secondary } = props;
  const { colorMode, toggleColorMode } = useColorMode();
  const [isNotifOpen, setIsNotifOpen] = useState(false);
    const [selectEmployeeId, setSelectedEmployeeId] = useState('');
    const [empPerformanceData, setEmpPerformanceData] = useState([]);

       const [selfCount, setSelfCount] = useState(0);  // State for SelfCount
   const [appraisalTeamCount, setAppraisalTeamCount] = useState(0);        // State for Appraisal Team Count

     const [loading, setLoading] = useState(false);
  // Chakra Color Mode
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.700", "brand.400");
  const ethColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
  const ethBox = useColorModeValue("white", "navy.800");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );


    useEffect(() => {
      const user = localStorage.getItem("user");
      const userData = user ? JSON.parse(user) : null;
      console.log("User Data from localStorage:", userData);
      if (userData) {
        setSelectedEmployeeId(userData.id || 0);

        console.log("Selected Employee ID:", userData.id);
        console.log("User Data ID:", selectEmployeeId);
        //setManagerId(userData.id || null);
        getCountsOnNotifications(userData.id || 0);
      }
    }, []);

  const handleLogout = async () => {
    try {
      await AuthApi.Logout();
    } catch (error) {
      console.error("Error during logout:", error);
    }

    setUser(null);
    localStorage.removeItem("user");
    history.push("/auth/sign-in");
  };
     const getCountsOnNotifications = async(id) => {
  setLoading(true);
 
  try {
    const response = await axios.get(
      `/PerformanceReview/getCount?employee_id=${id}`
    );

console.log("API Response:", response.data); // Debug log
   const data = response.data;

        if (data && data.length > 0) {
          setEmpPerformanceData(data);  // Set the full data array
          setSelfCount(data[0].SelfCount || 0);  // Set SelfCount from the API response
          setAppraisalTeamCount(data[0].Appraisal_TeamCount || 0);  // Set AppraisalTeamCount from the API response
        }
  } catch (error) {
    console.error("Error loading template/review data", error);
  } finally {
    setLoading(false);
  }
};
 
  // 🧠 Handle window/tab close
  useEffect(() => {
    const handleWindowClose = async (event) => {
      // Optionally prevent prompt (depends on browser support)
      event.preventDefault();

      // Call your logout logic
      try {
        await AuthApi.Logout();
      } catch (err) {
        console.error("Error during auto-logout:", err);
      }

      // Clear localStorage and reset user
      localStorage.removeItem("user");
      setUser(null);
    };

    // Add event listener for close
    window.addEventListener("beforeunload", handleWindowClose);

    // Cleanup
    return () => {
      window.removeEventListener("beforeunload", handleWindowClose);
    };
  }, [setUser]);


  const getGreetingMessage = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return "Good Morning";
  if (hour >= 12 && hour < 17) return "Good Afternoon";
  if (hour >= 17 && hour < 21) return "Good Evening";
  return "Hello";
};



  useEffect(() => {
    setIsNotifOpen(true);
    const timer = setTimeout(() => setIsNotifOpen(false), 3000);
    return () => clearTimeout(timer);
  }, []); 



  const userData = localStorage.getItem("user");
  const userName = userData ? JSON.parse(userData).name : "User";
  const greetingMessage = `${getGreetingMessage()}, ${userName}!`;


    // Directly access counts from empPerformanceData
 
  // // Check if the data is available and access the counts correctly
  // const selfCount = empPerformanceData[0]?.SelfCount || 0;  // Access SelfCount if available
  // const appraisalTeamCount = empPerformanceData[0]?.Appraisal_TeamCount || 0; // Access Appraisal_TeamCount if available

  // Watch and log changes to empPerformanceData, selfCount, and appraisalTeamCount
  useEffect(() => {
    console.log("empPerformanceData updated:", empPerformanceData);
  }, [empPerformanceData]);

  useEffect(() => {
    console.log("selfCount updated:", selfCount);
  }, [selfCount]);

  useEffect(() => {
    console.log("appraisalTeamCount updated:", appraisalTeamCount);
  }, [appraisalTeamCount]);
  const borderButton = useColorModeValue("secondaryGray.500", "whiteAlpha.200");
  return (
    <Flex
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
      p="10px"
      borderRadius="30px"
      boxShadow={shadow}
    >
      <SearchBar
        mb={secondary ? { base: "10px", md: "unset" } : "unset"}
        me="10px"
        borderRadius="30px"
      />
      {/* <Flex
        bg={ethBg}
        display={secondary ? "flex" : "none"}
        borderRadius='30px'
        ms='auto'
        p='6px'
        align='center'
        me='6px'>
        <Flex
          align='center'
          justify='center'
          bg={ethBox}
          h='29px'
          w='29px'
          borderRadius='30px'
          me='7px'>
          <Icon color={ethColor} w='9px' h='14px' as={FaEthereum} />
        </Flex>
        <Text
          w='max-content'
          color={ethColor}
          fontSize='sm'
          fontWeight='700'
          me='6px'>
          1,924
          <Text as='span' display={{ base: "none", md: "unset" }}>
            {" "}
            ETH
          </Text>
        </Text>
      </Flex> */}
      
      <SidebarResponsive routes={routes} />
      <Menu isOpen={isNotifOpen} onClose={() => setIsNotifOpen(false)} onOpen={() => setIsNotifOpen(true)}>
        <MenuButton p="0px">
          <Icon
            mt="6px"
            as={MdNotificationsNone}
            color={navbarIcon}
            w="18px"
            h="18px"
            me="10px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="20px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          me={{ base: "30px", md: "unset" }}
          minW={{ base: "unset", md: "400px", xl: "450px" }}
          maxW={{ base: "360px", md: "unset" }}
        >
          <Flex jusitfy="space-between" w="100%" mb="20px">
            <Text fontSize="md" fontWeight="600" color={textColor}>
              Notifications
            </Text>
          </Flex>
          <Flex flexDirection="column">
             <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              px="0"
              borderRadius="8px"
              mb="10px"
            >
               <ItemContent info="Employee Portal" aName="Alicia" description={greetingMessage} />
            </MenuItem>
 
   {/* Second Menu Item - Self Review with Badge */}
    <MenuItem
      _hover={{ bg: "none" }}
      _focus={{ bg: "none" }}
      px="0"
      borderRadius="8px"
      mb="10px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Text fontSize="md" fontWeight="600" color={textColor}>
        Self Review
      </Text>
      <Badge colorScheme="blue" variant="solid">
        {selfCount}
      </Badge>
    </MenuItem>

    {/* Third Menu Item - Annual Appraisal with Badge */}
    <MenuItem
      _hover={{ bg: "none" }}
      _focus={{ bg: "none" }}
      px="0"
      borderRadius="8px"
      mb="10px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Text fontSize="md" fontWeight="600" color={textColor}>
        Annual Appraisal
      </Text>
      <Badge colorScheme="green" variant="solid">
                {appraisalTeamCount}

      </Badge>
    </MenuItem>
          </Flex>
        </MenuList>
      </Menu>

      <Button
        variant="no-hover"
        bg="transparent"
        p="0px"
        minW="unset"
        minH="unset"
        h="18px"
        w="max-content"
        onClick={toggleColorMode}
      >
        <Icon
          me="10px"
          h="18px"
          w="18px"
          color={navbarIcon}
          as={colorMode === "light" ? IoMdMoon : IoMdSunny}
        />
      </Button>
      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: "pointer" }}
            color="white"
            name={userName}
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              👋&nbsp; Hey, {userName}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              borderRadius="8px"
              onClick={() => history.push("/admin/profile")}
              px="14px"
            >
              <Text fontSize="sm">My Profile</Text>
            </MenuItem>
          <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              borderRadius="8px"
              onClick={() => history.push("/admin/change_password")}
              px="14px"
            >
              <Text fontSize="sm">Change Password</Text>
            </MenuItem>
            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              onClick={handleLogout}
            >
              <Text fontSize="sm">Log out</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
